import React, { PureComponent, ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { MODAL_HIDE, MODAL_ROOT_ID, MODAL_SHOW } from './constants';
import { Body, Container, Footer, Header } from './Parts';
import { ModalProps } from './types';

class Modal extends PureComponent<ModalProps> {
  private readonly container: HTMLElement;

  private readonly modalRoot: HTMLElement | null;

  public constructor(props: ModalProps) {
    super(props);
    this.container = this.createContainer();
    this.modalRoot = document.getElementById(MODAL_ROOT_ID);
  }

  public componentDidMount(): void {
    if (this.modalRoot) {
      this.modalRoot.appendChild(this.container);
      if (this.props.onOpen) {
        $(this.container).on('shown.bs.modal', this.props.onOpen);
      }
      if (this.props.onClose) {
        $(this.container).on('hidden.bs.modal', this.props.onClose);
      }
      this.handleModalToggle(MODAL_SHOW);
    }
  }

  public componentWillUnmount(): void {
    this.handleModalToggle(MODAL_HIDE);
    if (this.modalRoot) {
      this.modalRoot.removeChild(this.container);
    }
  }

  public readonly handleModalToggle = (
    action: typeof MODAL_SHOW | typeof MODAL_HIDE,
  ): NodeJS.Timeout => setTimeout(() => $(this.container).modal(action), 100);

  public readonly createContainer = (): HTMLDivElement => {
    const container = document.createElement('div');
    container.classList.add('modal', 'fade', 'pb-modal');
    return container;
  };

  public readonly renderModal = (): ReactNode => (
    <Container narrow={this.props.narrow} wide={this.props.wide}>
      <Header onClose={this.props.onClose} title={this.props.title} />
      <Body noPadding={this.props.noPadding} noScroll={this.props.noScroll}>
        {this.props.children}
      </Body>
      {this.props.footer && <Footer>{this.props.footer}</Footer>}
    </Container>
  );

  public render(): ReactNode {
    if (!this.modalRoot) return null;
    return createPortal(this.renderModal(), this.container);
  }
}

export default Modal;
